module.exports = __webpack_public_path__ + "img/gal_24.8c203ce0.png";